import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import SelectFormField from "../../components/global/SelectFormField/SelectFormField";
import DatePickerInput from "../../components/global/DatePicker/DatePickerInput";
import useComponentVisible from "../../components/global/OutsideClick/useComponentVisible";
import RangePickerInput from "../../components/global/DatePicker/RangePickerInput";
import InputRange from "../../components/global/MaskedInput/InputRange";
import {
  GetAllBillingDetails,
  GetBillingDetails,
} from "../../features/managebilling/manageBillingSlice";
import { useDispatch } from "react-redux";
import { setInvoiceFilters } from "../../features/invoice/invoiceSlice";
import moment from "moment";

function InvoicesFilter({
  DealTypeOptions,
  LawyerOptions,
  StatusOptions,
  onFilter,
  isPastPayment,
  selectedOutstandingInvoices,
  setspayCheckedInvoices,
  setChequePaymentWarning,
  cheque,
  PaymentMethodOptions,
  isLawyer,
  firmId,
  userId,
  eft,
  isInternalUser,
}) {
  const isFirstRender = useRef(true);

  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);
  const [datepicker, setDatePicker] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [rangeIsOpen, setRangeIsOpen] = useState(false);
  const closingDateRef = useRef(null);
  const rangeRef = useRef(null);

  const {
    register,
    control,
    reset,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ClosingDateFilter: ["", ""],
      datePicker: "",
      DealTypeFilter: "",
      LawyerFilter: "",
      PaymentTypeFilter: "",
      search: "",
      RangeTypeFilter: [0, 0],
    },
    mode: "onBlur",
  });
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const dropdownChange = (e, name) => {
    setValue(name, e);
    trigger(name);
  };
  const closingDate = watch("ClosingDateFilter");
  const DealType = watch("DealTypeFilter");
  const LawyerName = watch("LawyerFilter");
  const paymentMethod = watch("PaymentTypeFilter");
  const datePickerValue = watch("datePicker");
  const rangeValue = watch("RangeTypeFilter");
  const search = watch("search");
  const [tempValue, setTempValue] = useState(rangeValue);

  const formatDateForBackend = (date) => {
    if (!date) return "";
    const parsedDate = moment(date);
    return parsedDate.isValid() ? parsedDate.format("MM/DD/YYYY") : "";
  };

  useEffect(() => {
    // if (!datepicker) {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (
      !DealType &&
      !LawyerName &&
      !paymentMethod &&
      (Array.isArray(closingDate)
        ? closingDate?.every((val) => !val)
        : !closingDate) &&
      rangeValue.every((val) => val === 0) &&
      !search
    ) {
      dispatch(setInvoiceFilters(false));
      return;
    }
    const rangeIsIncomplete = (rangeValue[0] > 0 && rangeValue[1] === 0) || (rangeValue[0] > rangeValue[1]);
    if (rangeIsIncomplete) return;

    const formattedClosingDate = Array.isArray(closingDate)
      ? closingDate.map((date) => formatDateForBackend(date))
      : ["", ""];

    const handler = setTimeout(() => {
      onFilter({
        closingDate:
          closingDate?.every((val) => val) && formattedClosingDate.length
            ? formattedClosingDate
            : ["", ""],
        DealType,
        LawyerName,
        paymentMethod,
        rangeValue,
        search,
      });
    }, 500);

    dispatch(
      setInvoiceFilters(
        Boolean(
          DealType ||
          LawyerName ||
          paymentMethod ||
          closingDate.some((val) => val) ||
          rangeValue.some((val) => val !== 0) ||
          search,
        ),
      ),
    );
    return () => {
      clearTimeout(handler);
    };
    // } else {
    //   onFilter({
    //     closingDate,
    //     DealType,
    //     LawyerName,
    //     paymentMethod,
    //     rangeValue,
    //     search,
    //   });
    // }
    // return () => {
    //   clearTimeout(handler);
    // };
  }, [
    //closingDate?.every((val) => val),
    closingDate,
    DealType,
    LawyerName,
    paymentMethod,
    search,
    datePickerValue,
    rangeValue,
  ]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const isFiltered = Boolean(
      DealType ||
      LawyerName ||
      paymentMethod ||
      closingDate.some((val) => val) ||
      rangeValue.some((val) => val !== 0) ||
      search,
    );
    if (!isFiltered) {
      onFilter({
        closingDate: ["", ""],
        DealType: "",
        LawyerName: "",
        paymentMethod: "",
        rangeValue: [0, 0],
        search: "",
      });
    }
  }, [search]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (closingDateRef.current && !closingDateRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (rangeRef.current && !rangeRef.current.contains(event.target)) {
        setRangeIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const renderFilterForm = (
    <div className="flex flex-row gap-[12px] pb-[24px]">
      {!isPastPayment && (
        <SelectFormField
          options={DealTypeOptions}
          dropdownChange={dropdownChange}
          control={control}
          // loading={loading}
          value={DealType}
          fieldName="DealTypeFilter"
          ariaLabel="Deal Type"
          selectClassNames="custom__dropdown-wrapper h-[40px] w-[140px]"
          defaultOption={
            <span className="break-keep current__label-value font-[600] font-open-sans leading-[21.79px] text-[#231F20] text-[16px] text-start w-full">
              {t("DealType")}
            </span>
          }
        />
      )}
      {(!isLawyer || isInternalUser) && (
        <SelectFormField
          options={LawyerOptions}
          dropdownChange={dropdownChange}
          control={control}
          value={LawyerName}
          // loading={loading}
          fieldName="LawyerFilter"
          ariaLabel="Deal Type"
          selectClassNames="custom__dropdown-wrapper h-[40px] w-[140px]"
          defaultOption={
            <span class="break-keep current__label-value font-[600] font-open-sans leading-[21.79px] text-[#231F20] text-[16px] text-start w-full">
              {t("Lawyer")}
            </span>
          }
        />
      )}
      <SelectFormField
        options={PaymentMethodOptions}
        dropdownChange={dropdownChange}
        control={control}
        value={paymentMethod}
        // loading={loading}
        fieldName="PaymentTypeFilter"
        ariaLabel={!isPastPayment ? "Payment Type" : "Payment Method"}
        selectClassNames={
          !isPastPayment
            ? "custom__dropdown-wrapper h-[40px] w-[168px]"
            : "custom__dropdown-wrapper h-[40px] w-[220px]"
        }
        defaultOption={
          !isPastPayment ? (
            <span class="break-keep current__label-value font-[600] font-open-sans leading-[21.79px] text-[#231F20] text-[16px] text-start">
              {t("BillingType")}{" "}
            </span>
          ) : (
            <span class="break-keep current__label-value font-[600] font-open-sans leading-[21.79px] text-[#231F20] text-[16px] text-start w-full">
              {t("PaymentMethod")}
            </span>
          )
        }
      />

      <div
        className={
          !isPastPayment
            ? "custom__dropdown-wrapper h-[40px] w-[160px]"
            : "custom__dropdown-wrapper h-[40px] w-[220px]"
        }
      // style={{ marginTop: "-38px", border: "5px solid black" }}
      >
        {/* <div className="custom__dropdown-wrapper h-[40px] mr-4 w-[138px]"> */}
        {!datepicker ? (
          <div>
            <Controller
              control={control}
              name={`ClosingDateFilter`}
              render={({ field, value }) => (
                <div>
                  <button
                    {...field}
                    onClick={() => {
                      setIsOpen(!isOpen);
                      setRangeIsOpen(false);
                    }}
                    placeholder="Select date range"
                    readOnly
                    className="!border-[#231F20] !px-[10px] !py-[9px] custom__dropdown justify-between"
                  >
                    <span class="break-keep current__label-value font-[600] font-open-sans leading-[21.79px] text-[#231F20] text-[16px] text-start w-full">
                      {" "}
                      {!isPastPayment
                        ? t("ClosingDate")
                        : t("PaymentDateRange")}{" "}
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="8"
                      fill="none"
                    >
                      <path
                        d="m1 1 6 6 6-6"
                        stroke="#231F20"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                  <div
                    className="pl-8 py-6 shadow-md"
                    style={{
                      height: "110px",
                      width: "300px",
                      border: "1px solid #000",
                      background: "white",
                    }}
                  >
                    {isOpen && (
                      <DatePickerInput
                        field={field}
                        value={datePickerValue}
                        register={register}
                        dateRange
                        datepicker={datepicker}
                        setDatePicker={setDatePicker}
                      />
                    )}
                  </div>
                </div>
              )}
            />
          </div>
        ) : (
          <Controller
            control={control}
            name={`ClosingDateFilter`}
            ariaLabel="Date Range"
            render={({ field, value }) => (
              <div>
                <button
                  {...field}
                  onClick={() => {
                    setIsOpen(!isOpen);
                    setRangeIsOpen(false);
                  }}
                  placeholder="Select date range"
                  readOnly
                  className="!border-[#231F20] !px-[10px] !py-[9px] custom__dropdown justify-between"
                >
                  <span class="break-keep current__label-value font-[600] font-open-sans leading-[21.79px] text-[#231F20] text-[16px] text-start w-full">
                    {" "}
                    {!isPastPayment
                      ? t("ClosingDate")
                      : t("PaymentDateRange")}{" "}
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="8"
                    fill="none"
                  >
                    <path
                      d="m1 1 6 6 6-6"
                      stroke="#231F20"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>

                {isOpen && (
                  <div
                    className="pl-8 py-6 shadow-md"
                    style={{
                      height: "250px",
                      width: "300px",
                      border: "1px solid #000",
                      background: "white",
                    }}
                    ref={closingDateRef}
                  >
                    <RangePickerInput
                      value={closingDate}
                      register={register}
                      datepicker={datepicker}
                      setDatePicker={setDatePicker}
                      onChange={(dateArray) => {
                        setValue("ClosingDateFilter", dateArray);
                        trigger("ClosingDateFilter");
                        //setIsOpen(false);
                      }}
                      dateRange
                    />
                  </div>
                )}
              </div>
            )}
          />
        )}
        {/* </div> */}
      </div>
      {/* <SelectFormField
        options={StatusOptions}
        dropdownChange={dropdownChange}
        control={control}
        value={rangeValue}
        // loading={loading}
        fieldName='RangeTypeFilter'
        ariaLabel='Select Range'
        selectClassNames='custom__dropdown-wrapper h-[40px] w-[158px]'
        defaultOption={`Select Range`}
      /> */}
      <div
        className={
          !isPastPayment
            ? "custom__dropdown-wrapper h-[40px] w-[160px]"
            : "custom__dropdown-wrapper h-[40px] w-[220px]"
        }
      // style={{ marginTop: "-38px", border: "5px solid black" }}
      >
        {/* <div className="custom__dropdown-wrapper h-[40px] mr-4 w-[138px]"> */}
        <Controller
          control={control}
          name={`TotalRangeFilter`}
          ariaLabel="Total Range"
          render={({ field, value }) => (
            <div>
              <button
                {...field}
                onClick={() => {
                  setRangeIsOpen(!rangeIsOpen);
                  setIsOpen(false);
                }}
                readOnly
                className="!border-[#231F20] !px-[10px] !py-[9px] custom__dropdown justify-between"
              >
                <span class="break-keep current__label-value font-[600] font-open-sans leading-[21.79px] text-[#231F20] text-[16px] text-start w-full">
                  {" "}
                  {t("totalRange")}{" "}
                </span>
                <div class="flex h-[24px] items-center justify-center w-[24px]">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="8"
                    fill="none"
                  >
                    <path
                      d="m1 1 6 6 6-6"
                      stroke="#231F20"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </button>

              {rangeIsOpen && (
                <div
                  className="pl-8 py-6 shadow-md"
                  style={{
                    height: "180px",
                    width: "460px",
                    border: "1px solid #000",
                    background: "white",
                  }}
                  ref={rangeRef}
                >
                  <InputRange
                    setValue={setValue}
                    trigger={trigger}
                    value={rangeValue}
                    maxLimitValue={1000000}
                    fieldName="RangeTypeFilter"
                    testId="RangeTypeFilter"
                    tempValue={tempValue}
                    setTempValue={setTempValue}
                  />
                </div>
              )}
            </div>
          )}
        />
        {/* </div> */}
      </div>

      <button
        id="filter-clear"
        onClick={() => {
          reset();
          setTempValue([]);
          onFilter({
            closingDate: ["", ""],
            DealType: "",
            LawyerName: "",
            paymentMethod: "",
            rangeValue: [0, 0],
            search: "",
          });
        }}
        className="font-[600] font-open-sans leading-[19.07px] px-[8px] text-[#526D7D] text-[14px]"
      >
        {t("Clear")}
      </button>
    </div>
  );

  const renderSearchField = (
    <div className="custom__icon-textfield relative">
      <input
        type="text"
        id="headerSearch"
        className="placeholder-placeholder"
        aria-label="Header search"
        value={search}
        {...register(`search`)}
        placeholder="Search Order #, Ref #, Property address..."
      />
      <img
        src="../../images/search-icon.527ce689.svg"
        className="!h-[20px] !w-[20px] absolute left-[16px] top-[10px]"
        alt="search icon"
      />
    </div>
  );

  return (
    <div className="flex flex-row gap-[16px] pb-[24px]">
      {!isPastPayment && (
        <div role="application">
          <div className="h-[40px] w-[482px]">{renderSearchField}</div>
        </div>
      )}
      <div>
        {!isPastPayment && (
          <a
            href="#"
            id="filter-icon-dropdown"
            className="bg-white border border-placeholder flex h-[40px] items-center justify-center rounded-sm w-[96px]"
            aria-label="Filter icon"
          >
            <div className="flex h-[24px] items-center justify-center mr-1 w-[24px]">
              <svg width="20" height="20" fill="none">
                <path
                  d="M5 16v-5M5 9V4M10 16v-6M10 7V4M15 16v-3M15 10V4M3 11h4M8 7h4M13 13h4"
                  stroke="#000"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <button
              className="font-[600] text-[#231F20] text-[16px]"
              onClick={() => setIsComponentVisible(!isComponentVisible)}
            >
              {t("Filter")}
            </button>
          </a>
        )}
        {isPastPayment ? (
          <div id="filter-container" className="flex flex-row p-2">
            <div className="h-[40px] w-[400px] mr-2">{renderSearchField}</div>
            {renderFilterForm}
          </div>
        ) : (
          <div ref={ref}>
            {isComponentVisible && (
              <div
                id="filter-dropdown"
                className="absolute bg-white border border-primary-yellow h-[100px] p-4 rounded-sm top-[400px] mt-1 w-[820px] z-10"
                style={{
                  borderRadius: "4px",
                  boxShadow: "0 4px 14px #0000001a",
                }}
              >
                <div
                  id="filter-container"
                  className="flex flex-row p-2 space-x-5"
                >
                  {renderFilterForm}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      {!isPastPayment && (
        <>
          <button
            className="font-[600] font-open-sans leading-[19.07px] px-[14px] text-[#526D7D] text-[14px]"
            onClick={() => {
              reset();
              onFilter({
                closingDate: ["", ""],
                DealType: "",
                LawyerName: "",
                paymentMethod: "",
                rangeValue: [0, 0],
                search: "",
              });
            }}
          >
            {t("ClearFilter")}
          </button>
          <div className="flex ml-auto mr-0">
            <p className="flex items-center justify-center mr-4">
              <span id="checked_invoices"></span>
              {selectedOutstandingInvoices?.length} invoices selected
            </p>
            <button
              id="pay-invoices"
              disabled={selectedOutstandingInvoices?.length === 0}
              className="btn__primary font-[600] leading-[19.07px] px-[14px] text-[16px] w-[200px]"
              // onclick='showDialog()'
              onClick={() => {
                if (cheque?.length > 0 || eft?.length > 0) {
                  setChequePaymentWarning(true);
                } else {
                  setspayCheckedInvoices(true);
                }
                // if (isLawyer) {
                //   dispatch(GetBillingDetails(firmId, userId, userId));
                // } else if (selectedOutstandingInvoices?.length === 1) {
                //   dispatch(
                //     GetBillingDetails(
                //       firmId,
                //       selectedOutstandingInvoices?.original?.lawyerID,
                //       userId
                //     )
                //   );
                // } else {
                dispatch(
                  GetAllBillingDetails(
                    firmId,
                    selectedOutstandingInvoices,
                    userId,
                  ),
                );
                // }
              }}
            >
              <div className="flex items-center justify-center">
                Pay checked invoices
              </div>
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default React.memo(InvoicesFilter);
